module.exports = __webpack_public_path__ + "static/media/done.e8ca4ba2.jpg";